'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = require('../../node_modules/@babel/runtime/helpers/esm/extends.js');

var React = require('react');

var index = require('../../node_modules/gatsby-link/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var isExternalLink = function isExternalLink(url) {
  try {
    return new URL(url).origin !== location.origin;
  } catch (err) {
    return false;
  }
};

var GatsbyLink = function GatsbyLink(props) {
  var href = props.href,
      children = props.children;

  if (isExternalLink(href)) {
    return /*#__PURE__*/React__default['default'].createElement("a", _extends['default']({
      href: href
    }, props), children);
  } else {
    return /*#__PURE__*/React__default['default'].createElement(index['default'], _extends['default']({
      to: href
    }, props), children);
  }
};

exports.GatsbyLink = GatsbyLink;
exports.isExternalLink = isExternalLink;